import React from "react";
import PageShell from "../../components/layout/PageShell";

export default function Mission() {
  return (
    <PageShell
      title="Mission & Vision"
      subtitle="Notre engagement pour une justice de qualité en Haïti"
    >
      {/* Mission */}
      <section className="ema-block">
        <h2 className="ema-h3">Notre mission</h2>
        <p className="ema-paragraph">
          L'École de la Magistrature a pour mission de former des magistrats et des greffiers compétents, éthiques
          et indépendants, capables de servir la justice haïtienne avec excellence. Nous nous engageons à :
        </p>
        <ul className="ema-list" style={{ marginTop: 12 }}>
          <li>Assurer une formation professionnelle de haute qualité</li>
          <li>Développer les compétences techniques et humaines des futurs magistrats</li>
          <li>Renforcer l'intégrité morale et la déontologie judiciaire</li>
          <li>Garantir l'indépendance et l'impartialité de la justice</li>
          <li>Contribuer à la modernisation du système judiciaire haïtien</li>
          <li>Promouvoir l'accès à la justice pour tous les citoyens</li>
        </ul>
      </section>

      <div className="ema-divider" />

      {/* Vision */}
      <section className="ema-block">
        <h2 className="ema-h3">Notre vision</h2>
        <p className="ema-paragraph">
          Nous aspirons à être l'institution de référence pour la formation des magistrats en Haïti et dans la
          région des Caraïbes. Notre vision est de :
        </p>
        <div className="ema-grid-3" style={{ marginTop: 14 }}>
          <VisionCard
            title="Excellence académique"
            text="Offrir des programmes de formation reconnus pour leur qualité et leur pertinence."
          />
          <VisionCard
            title="Innovation pédagogique"
            text="Intégrer les méthodes modernes d'enseignement et les technologies éducatives."
          />
          <VisionCard
            title="Impact sociétal"
            text="Former des magistrats qui transforment positivement le système judiciaire."
          />
        </div>
      </section>

      <div className="ema-divider" />

      {/* Valeurs */}
      <section className="ema-block">
        <h2 className="ema-h3">Nos valeurs</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <ValueCard
            title="Intégrité"
            description="Nous cultivons la probité, l'honnêteté et l'éthique professionnelle."
          />
          <ValueCard
            title="Excellence"
            description="Nous visons la plus haute qualité dans notre formation et nos services."
          />
          <ValueCard
            title="Indépendance"
            description="Nous respectons et promouvons l'autonomie judiciaire."
          />
          <ValueCard
            title="Équité"
            description="Nous défendons la justice égale pour tous les citoyens."
          />
          <ValueCard
            title="Professionnalisme"
            description="Nous maintenons des standards élevés dans toutes nos activités."
          />
          <ValueCard
            title="Innovation"
            description="Nous nous adaptons aux évolutions du droit et de la société."
          />
        </div>
      </section>

      <div className="ema-divider" />

      {/* Engagement */}
      <section className="ema-block">
        <h2 className="ema-h3">Notre engagement</h2>
        <p className="ema-paragraph">
          L'EMA s'engage à former des magistrats qui :
        </p>
        <div className="ema-timeline" style={{ marginTop: 14 }}>
          <Timeline n="1" title="Compétence technique" text="Maîtrisent le droit et les procédures judiciaires." />
          <Timeline n="2" title="Intégrité morale" text="Agissent avec probité et respect de la déontologie." />
          <Timeline n="3" title="Indépendance" text="Prennent des décisions impartiales et libres de toute influence." />
          <Timeline n="4" title="Service public" text="Servent les citoyens avec professionnalisme et accessibilité." />
        </div>
      </section>
    </PageShell>
  );
}

function VisionCard({ title, text }) {
  return (
    <div className="ema-card ema-card-highlight">
      <h3 className="ema-h3">{title}</h3>
      <p className="ema-paragraph">{text}</p>
    </div>
  );
}

function ValueCard({ title, description }) {
  return (
    <div className="ema-panel">
      <h3 className="ema-h3">{title}</h3>
      <p className="ema-paragraph">{description}</p>
    </div>
  );
}

function Timeline({ n, title, text }) {
  return (
    <div className="ema-step">
      <div className="ema-step-num">{n}</div>
      <div className="ema-step-body">
        <h3 className="ema-h3" style={{ margin: 0 }}>{title}</h3>
        <p className="ema-paragraph" style={{ marginTop: 10 }}>{text}</p>
      </div>
    </div>
  );
}
